// A team's path through the bracket, from the 8 match results (`winners`, team names, '' while undecided): every match
// it's in, the next one it plays (both sides known), the last one it played, and a one-line fate ("Lost the
// quarterfinal to Blue", "Next: the final against Brown"). Shared by the team section and the team card.

export const ROUND = ['quarterfinal', 'quarterfinal', 'quarterfinal', 'quarterfinal', 'semifinal', 'semifinal', 'final', 'champion match'];
export const TITLES = ['Quarterfinal 1', 'Quarterfinal 2', 'Quarterfinal 3', 'Quarterfinal 4', 'Semifinal 1', 'Semifinal 2', 'Final', 'Champion match'];
// What fills an undecided side of each match.
const FEED = [null, null, null, null, ['QF 1', 'QF 2'], ['QF 3', 'QF 4'], ['SF 1', 'SF 2'], ['the Final', null]];

export function matchPairs(W = []) {
  return [['red', 'blue'], ['green', 'yellow'], ['white', 'black'], ['purple', 'brown'], [W[0], W[1]], [W[2], W[3]], [W[4], W[5]], [W[6], 'champion']];
}

// name: the team ('red' … 'champion'); label(name) → its display name ("Blue", "the Champion").
export function teamPath(name, winners, label = (n) => n) {
  const W = winners || [], pairs = matchPairs(W);
  const matches = [];
  let next = -1, last = -1;
  pairs.forEach(([a, b], i) => {
    if (a !== name && b !== name) return;
    const oppKey = a === name ? b : a;
    const feed = FEED[i] && FEED[i][a === name ? 1 : 0];
    const result = W[i] ? (W[i] === name ? 'won' : 'lost') : 'upcoming';
    matches.push({ i, oppKey: oppKey || null, oppLabel: oppKey ? label(oppKey) : 'Winner of ' + feed, result });
    if (!W[i] && next < 0 && a && b) next = i;
    if (W[i]) last = i;
  });
  const lost = matches.find((m) => m.result === 'lost');
  const pending = matches.find((m) => m.result === 'upcoming');
  let fate;
  if (W[7] === name) fate = name === 'champion' ? 'Defended the title' : 'Won the title';
  else if (lost) fate = `Lost the ${ROUND[lost.i]} to ${lost.oppLabel}`;
  else if (next >= 0) fate = `Next: the ${ROUND[next]} against ${label(pairs[next][0] === name ? pairs[next][1] : pairs[next][0])}`;
  else if (pending && name !== 'champion') fate = `Next: the ${ROUND[pending.i]}`;
  else fate = name === 'champion' ? 'Awaiting a challenger' : 'Waiting on the bracket';
  // the team it faces next, else the one it last faced
  const foeAt = next >= 0 ? next : last;
  const foeKey = foeAt >= 0 ? (pairs[foeAt][0] === name ? pairs[foeAt][1] : pairs[foeAt][0]) : null;
  return { matches, next, last, foeAt, foeKey, fate };
}

// Which matches feed each side of matches 4–7 (null = a fixed side: the champion's).
const FEEDS = [null, null, null, null, [0, 1], [2, 3], [4, 5], [6, null]];

// The teams that could still come out of match i.
function contenders(i, W, pairs) {
  if (W[i]) return [W[i]];
  if (i < 4) return pairs[i].slice();
  return FEEDS[i].flatMap((f) => (f == null ? ['champion'] : contenders(f, W, pairs)));
}

// When the team's next match has an undecided other side: that match and every team that could still fill it
// (the two teams of the feeding quarterfinal; for the champion before the Final, every team still alive).
// Null when the next opponent is known, or the team is out.
export function possibleFoes(name, winners) {
  const W = winners || [], pairs = matchPairs(W);
  for (let i = 4; i < 8; i++) {
    const [a, b] = pairs[i];
    if (W[i] || (a !== name && b !== name) || (a && b)) continue;
    const side = a === name ? 1 : 0, feed = FEEDS[i][side];
    if (feed == null) continue;
    return { at: i, from: feed, keys: contenders(feed, W, pairs).filter((k) => k && k !== name) };
  }
  return null;
}
